import {
  BackArrowActionsContainerMobile,
  OverviewAction,
  OverviewActionsContainer,
  OverviewBadgesContainer,
  OverviewCampaignCardContainer,
  OverviewCampaignCardContainerMobile,
  OverviewInfoContainer,
  OverviewSongImage,
  OverviewText,
  OverviewTitleContainer,
  SongName,
  useStyles,
} from "./styles";
import DefaultImg from "assets/images/music-key-green-bg.svg";
import { ReactComponent as ContextualMenuIcon } from "assets/images/contextualMenu.svg";
import CustomMenu, { MenuElement, ShowTooltip } from "components/shareable/CustomMenu/index";
import { ReactComponent as BackArrowIcon } from "assets/images/BackArrow.svg";
import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import CampaignStatusTag from "elements/CampaignStatusTag";
import useBrand from 'Hooks/useBrand';
import Colors from "modules/Colors";
import { CampaignStatus, CampaignType } from "modules/Const";
import Icon from "elements/Icon";
import TagSymphony from "elements/TagSymphony";
import { getCampaignTypeInfo } from "modules/Utils";

interface Props {
  goBack: () => void;

  name: string;
  thumbnail?: string;
  campaignStatus?: string;
  isLoading?: boolean;
  handleEditPresaveDesign: () => void;
  handleEditReleaseDate: () => void;
  handleEditUpcIsrc: () => void;
  handleEditBoost: () => void;
  handleEditPlatforms: () => void;

  handleEditUrl: () => void;
  handleArchivePresave: () => void;

  isFinalized?: boolean;
}

const PresaveOverviewCampaignCard = ({
  isLoading,
  goBack,
  name,
  thumbnail,
  campaignStatus = "pending",
  handleEditPresaveDesign,
  handleEditBoost,
  handleEditPlatforms,
  handleEditReleaseDate,
  handleEditUpcIsrc,
  handleEditUrl,
  handleArchivePresave,
  isFinalized,
}: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { isBrandAdmin } = useBrand();
  const isMdWidthScreen = useMediaQuery(theme.breakpoints.down(1024));

  const campaignName = name;

  const active = campaignStatus !== "finished";
  const isArchived = campaignStatus === CampaignStatus.ARCHIVED;

  const tooltipText = isFinalized ? "You can't edit once your campaign is finished." : ""

  const menuItems: MenuElement[] = [
    {
      icon: <Icon className={classes.svgGray} icon="edit" size={16} />,
      text: "Edit Presave Design",
      show: active && !isArchived,
      onClick: () => handleEditPresaveDesign(),
      disabled: isFinalized,
      tooltip: tooltipText,
    },
    {
      icon: <Icon className={classes.svgGray} icon="calendar" size={16} />,
      text: "Edit Release Date",
      show: active && !isArchived,
      onClick: () => handleEditReleaseDate(),
      disabled: isFinalized,
      tooltip: tooltipText,
    },
    {
      icon: <Icon className={classes.svgGray} icon="link" size={16} />,
      text: "Edit UPC/ISRC",
      show: active && !isArchived,
      onClick: () => handleEditUpcIsrc(),
      disabled: isFinalized,
      tooltip: tooltipText,
    },
    {
      icon: <Icon className={classes.svgGray} icon="boost" size={16} />,
      text: "Edit Boosts",
      show: active && !isArchived,
      onClick: () => handleEditBoost(),
      disabled: isFinalized,
      tooltip: tooltipText,
    },
    {
      icon: <Icon className={classes.svgGray} icon="bulletList" size={16} />,
      text: "Edit Platforms",
      show: active && !isArchived,
      onClick: () => handleEditPlatforms(),
      disabled: isFinalized,
      tooltip: tooltipText,
    },
    {
      icon: <Icon className={classes.svgGray} icon="link" size={16} />,
      text: "Edit URL",
      show: active && !isArchived,
      onClick: () => handleEditUrl(),
      disabled: isFinalized,
      tooltip: "",
    },
    {
      icon: <Icon className={classes.svgGray} icon="trash" size={16} />,
      text: "Archive Pre-save",
      show: !isArchived,
      onClick: () => handleArchivePresave(),
      disabled: false,
      tooltip: "",
    }
  ];

  const campaignImage = () => {
    return (
      <OverviewSongImage
        src={thumbnail || DefaultImg}
      />
    )
  };

  const renderBadges = () => {
    if (isLoading) return null;
    
    return (
      <>
        <TagSymphony
          icon={getCampaignTypeInfo(CampaignType.PRE_SAVE).icon}
          title={getCampaignTypeInfo(CampaignType.PRE_SAVE).title}
          className="presaveCampaignTypeTag"
          type="square"
        />
        <CampaignStatusTag
          status={campaignStatus}
          className="presaveCampaignStatusTag"
        />
      </>
    );
  };

  const renderEditMenu = () => {
    if (isLoading || !isBrandAdmin || isArchived) return null;
    
    return (
      <CustomMenu menuItems={getMenuItemsByStatus(campaignStatus)}>
        <OverviewAction
          color={isFinalized ? "#b2b2b2" : Colors.purple}
        >
          <ShowTooltip tooltip={tooltipText}>
            <Grid container>
              Edit
              <ContextualMenuIcon
                className={`${classes.actionIcon} ${isFinalized && classes.svgGray}`}
              />
            </Grid>
          </ShowTooltip>
        </OverviewAction>
      </CustomMenu>
    );
  };

  const renderTitleAndBadges = () => {
    return (
      <OverviewInfoContainer>
        <OverviewText>Overview</OverviewText>
        <SongName>{campaignName}</SongName>
        <OverviewBadgesContainer>
          {renderBadges()}
        </OverviewBadgesContainer>
      </OverviewInfoContainer>
    );
  };

  const getMenuItemsByStatus = (status: string) => {
    return menuItems;
  };

  if (isMdWidthScreen) {
    return (
      <OverviewCampaignCardContainerMobile className="presaveOverviewCampaignCardMobile">
        <BackArrowActionsContainerMobile>
          <BackArrowIcon style={{ cursor: 'pointer' }} onClick={goBack} />
          <OverviewActionsContainer>
            {renderEditMenu()}
          </OverviewActionsContainer>
        </BackArrowActionsContainerMobile>
        <OverviewTitleContainer>
          {campaignImage()}
          {renderTitleAndBadges()}
        </OverviewTitleContainer>
      </OverviewCampaignCardContainerMobile>
    );
  }

  return (
    <OverviewCampaignCardContainer className="presaveOverviewCampaignCard">
      <BackArrowIcon style={{ cursor: 'pointer' }} onClick={goBack} />
      <OverviewTitleContainer>
        {campaignImage()}
        {renderTitleAndBadges()}
      </OverviewTitleContainer>
      {renderEditMenu()}
    </OverviewCampaignCardContainer>
  );
};

export default PresaveOverviewCampaignCard;
